import { useChartCtx } from '@weenat/client/dist/core/charts'
import { DataPoint } from '@weenat/client/dist/core/charts/d3-charts.type'
import { isEmpty } from 'lodash-es'
import { ReactNode, useMemo } from 'react'

interface ChartGutterProps {
  data?: DataPoint[]
  renderItem: (args: { date: Date; value: number; y: number; x: number }) => ReactNode
  height?: number
}

const ChartGutter: FC<ChartGutterProps> = ({ data, height = 16, renderItem }) => {
  const { xScale, marginTop } = useChartCtx()

  const dataWithoutOverlapArrow: DataPoint[] = useMemo(() => {
    const filteredData: DataPoint[] = []
    data?.forEach((dp, index) => {
      if (
        index === 0 ||
        (!isEmpty(filteredData) && xScale(dp.date) - xScale(filteredData.slice(-1)[0].date) >= 10)
      )
        filteredData.push(dp)
    })
    return filteredData
  }, [data, xScale])

  const transform = `translate(0, ${marginTop - height})`

  return (
    <g transform={transform}>
      {dataWithoutOverlapArrow.map((dp) => {
        return renderItem({
          date: dp.date,
          value: dp.value,
          x: xScale(dp.date),
          y: height / 2
        })
      })}
    </g>
  )
}

export default ChartGutter
